import Kv from './_kv';
import SpKv from './_spkv';
import Topics from './_topics';
import CvBtn from './_cvbtn';
import Story from './_story';


export default class Main{

    constructor(){
        this._init();
    }


    _init(){
        this.kv = new Kv();
        this.spkv = new SpKv();
        this.topics = new Topics();
        this.cvbtn = new CvBtn();
        this.story = new Story();
    }
}
